import { useContext } from "react";

import UserContext from "../../context/User/User";
import AuthService from "../../utilities/services/auth.service";

import { ORGANIZATION_PERMISSION_SLUGS } from "@blocktickets/shared-utils";
import { checkPermission } from "../../utilities/helpers";

import { NoPermissionsContainer } from "../NoPermissionsContainer";
import { PageLoadingContainer } from "../PageLoadingContainer";

import { EventsList } from "./EventsList";

export default function HomeWrapper() {
  const { orgPermissions } = useContext(UserContext);
  const { getPermissions } = AuthService;

  const orgPermissionsReady = orgPermissions?.length > 0;
  const hasPermission =
    orgPermissionsReady &&
    checkPermission(
      getPermissions(),
      ORGANIZATION_PERMISSION_SLUGS.VIEW_EVENTS,
    );

  if (!orgPermissionsReady) {
    return <PageLoadingContainer style="without-sidebar" />;
  }

  if (!hasPermission) {
    return (
      <div className="spacer-sm">
        <NoPermissionsContainer style="without-sidebar" />
      </div>
    );
  }

  return (
    <>
      <section className="spacer-sm" data-testid="home-wrapper-events-section">
        <EventsList />
      </section>
    </>
  );
}
